const INITIAL_VALUES = {
  chainNum: '',
  chainName: '',
  agents: [],
};

export default INITIAL_VALUES;
